import { useTranslation } from 'react-i18next';

import { OrgMemberWithProfile } from '@/features/org/api/get-org-members';
import { useOrgMembersForProject } from '@/features/projects/create-project/hooks/use-org-members-for-project';
import { AddedItemsList } from '@/shared/components/added-items-list';

export const DefaultMemberInvitationList = ({
  members,
}: {
  members?: OrgMemberWithProfile[];
}) => {
  const { t } = useTranslation('project', { keyPrefix: 'InviteUsersForm' });
  const { data: orgMembers, isLoading } = members
    ? {
        data: members,
        isLoading: false,
      }
    : useOrgMembersForProject();

  const filteredMembers =
    members ??
    (orgMembers?.filter(
      (member: OrgMemberWithProfile) =>
        member.role === 'owner' || member.role === 'admin',
    ) ||
      []);

  if (isLoading || filteredMembers.length === 0) {
    return null;
  }

  return (
    <AddedItemsList
      items={filteredMembers.map((member) => ({
        id: member.user_id,
        title: member.profile?.email ?? 'Keine Angabe',
        subtitle: t(`roles.${member.role}`, { defaultValue: member.role }),
      }))}
    />
  );
};
